import { useTranslation } from "react-i18next";
import { LifestyleUseCasesData } from "./types";

// ✅ Helper function برای تبدیل امن به array
const ensureArray = (value: any): string[] => {
    if (Array.isArray(value)) {
        return value;
    }
    if (typeof value === "string") {
        return [value];
    }
    if (value && typeof value === "object") {
        return Object.values(value).filter((v): v is string => typeof v === "string");
    }
    return [];
};

export const useRingLifestyleData = (): LifestyleUseCasesData => {
    const { t } = useTranslation("ringLifestyle");

    return {
        categories: [
            { id: "morning", name: t("categories.morning") },
            { id: "work", name: t("categories.work") },
            { id: "health", name: t("categories.health") },
        ],

        useCases: [
            // Morning Scenarios
            {
                image: "../../../../media/landing/LifestyleUseCases/ring/1.webp",
                title: t("useCases.0.title"),
                description: t("useCases.0.description"),
                time: t("useCases.0.time"),
                category: "morning",
                color: "from-blue-400 to-indigo-500",
                main: true,
                tags: ensureArray(t("useCases.0.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/ring/2.webp",
                title: t("useCases.1.title"),
                description: t("useCases.1.description"),
                time: t("useCases.1.time"),
                category: "morning",
                color: "from-yellow-400 to-lime-500",
                main: true,
                tags: ensureArray(t("useCases.1.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/ring/3.webp",
                title: t("useCases.2.title"),
                description: t("useCases.2.description"),
                time: t("useCases.2.time"),
                category: "morning",
                color: "from-green-400 to-teal-500",
                main: true,
                tags: ensureArray(t("useCases.2.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/ring/4.webp",
                title: t("useCases.3.title"),
                description: t("useCases.3.description"),
                time: t("useCases.3.time"),
                category: "morning",
                color: "from-blue-400 to-cyan-500",
                main: true,
                tags: ensureArray(t("useCases.3.tags", { returnObjects: true })),
            },

            // Work Scenarios
            {
                image: "../../../../media/landing/LifestyleUseCases/ring/5.webp",
                title: t("useCases.4.title"),
                description: t("useCases.4.description"),
                time: t("useCases.4.time"),
                category: "work",
                color: "from-indigo-400 to-sky-500",
                main: true,
                tags: ensureArray(t("useCases.4.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/ring/6.webp",
                title: t("useCases.5.title"),
                description: t("useCases.5.description"),
                time: t("useCases.5.time"),
                category: "work",
                color: "from-purple-400 to-pink-400",
                main: true,
                tags: ensureArray(t("useCases.5.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/ring/7.webp",
                title: t("useCases.6.title"),
                description: t("useCases.6.description"),
                time: t("useCases.6.time"),
                category: "work",
                color: "from-teal-400 to-emerald-500",
                main: true,
                tags: ensureArray(t("useCases.6.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/ring/8.webp",
                title: t("useCases.7.title"),
                description: t("useCases.7.description"),
                time: t("useCases.7.time"),
                category: "work",
                color: "from-orange-400 to-amber-500",
                main: true,
                tags: ensureArray(t("useCases.7.tags", { returnObjects: true })),
            },

            // Health Scenarios
            {
                image: "../../../../media/landing/LifestyleUseCases/ring/9.webp",
                title: t("useCases.8.title"),
                description: t("useCases.8.description"),
                time: t("useCases.8.time"),
                category: "health",
                color: "from-lime-400 to-green-500",
                main: true,
                tags: ensureArray(t("useCases.8.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/ring/10.webp",
                title: t("useCases.9.title"),
                description: t("useCases.9.description"),
                time: t("useCases.9.time"),
                category: "health",
                color: "from-rose-400 to-pink-500",
                main: true,
                tags: ensureArray(t("useCases.9.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/ring/11.webp",
                title: t("useCases.10.title"),
                description: t("useCases.10.description"),
                time: t("useCases.10.time"),
                category: "health",
                color: "from-purple-400 to-indigo-500",
                main: true,
                tags: ensureArray(t("useCases.10.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/ring/12.webp",
                title: t("useCases.11.title"),
                description: t("useCases.11.description"),
                time: t("useCases.11.time"),
                category: "health",
                color: "from-blue-400 to-purple-500",
                main: true,
                tags: ensureArray(t("useCases.11.tags", { returnObjects: true })),
            },
        ],
    };
};
